import { useRef } from 'react';
import { Upload } from 'lucide-react';

/**
 * Simula upload de arquivo (sem backend).
 * Retorna { name, type, size } para ser usado como fonte de conhecimento.
 * Ponto de integração: substituir por upload real (multipart para API).
 *
 * @param {Object} props
 * @param {(result: { name: string, type: string, size: number }) => void} props.onFileMock
 * @param {string} [props.accept] - ex: ".pdf,.doc,.docx,.txt"
 * @param {string} [props.label]
 */
export default function UploadFileMock({ onFileMock, accept = '.pdf,.doc,.docx,.txt', label = 'Selecionar arquivo' }) {
  const inputRef = useRef(null);

  const handleChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    // Mock: apenas nome, tipo e tamanho (não envia para servidor)
    onFileMock({
      name: file.name,
      type: file.type || 'application/octet-stream',
      size: file.size,
    });
    e.target.value = '';
  };

  return (
    <div className="flex items-center gap-2">
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={handleChange}
        className="hidden"
        aria-label={label}
      />
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        className="inline-flex items-center gap-2 px-3 py-2 rounded-xl border-2 border-dashed border-appSurfaceBorder text-appTextMuted hover:border-appPrimary hover:text-appPrimary transition-all text-xs font-bold"
      >
        <Upload size={14} />
        {label}
      </button>
    </div>
  );
}
